import Gateway from '@/views/gateway/Gateway.vue';

export default [
  {
    path: '/gateway',
    name: 'gateway',
    component: Gateway,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () =>
      import(/* webpackChunkName: "search" */ '@/views/search/Search.vue')
  },
  {
    path: '/todayDeal',
    name: 'todayDeal',
    component: () =>
      import(
        /* webpackChunkName: "TodayDeal" */ '@/views/landingPage/todayDeal/TodayDeal.vue'
      )
  },
  {
    path: '/asinList/:dealId/:dealTitle/:pageTitle/:dealEndTime?',
    name: 'asinList',
    component: () =>
      import(
        /* webpackChunkName: "asinList" */ '@/views/landingPage/components/AsinList.vue'
      )
  },
  {
    path: '/download',
    name: 'downloadPage',
    component: () =>
      import(
        /* webpackChunkName: "downloadPage" */ '@/views/downloadPage/DownloadPage.vue'
      )
  },
  {
    path: '/landingPage',
    name: 'landingPage',
    component: () =>
      import(
        /* webpackChunkName: 'widget' */ '@/views/landingPage/LandingPage.vue'
      )
  }
];
